import 'reflect-metadata';
import {jsonObject, jsonMember, jsonArrayMember} from 'typedjson';

@jsonObject
export class Checkpoint {

  @jsonMember({name: 'id'})
  public Id!: string;

  @jsonArrayMember(String, {name: 'devices'})
  public Devices!: string[];

  @jsonMember({name: 'created'})
  public Created!: Date;

  @jsonMember({name: 'rollbackTimeout'})
  public RollbackTimeout!: number;
}
